export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
    className: 'col-opt',
    visible: !that.disabled,
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 70,
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_goodsName') || '产品名称',
    field: 'goodsName',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    minWidth: 220,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_amzSkuNo') || '产品编号',
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_displayAmzNo') || '产品贴标识',
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayAmzNo' },
  },
  {
    title: that.$l('table_label_poNo') || 'PO#订单号',
    field: 'poNo',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 50,
        'show-word-limit': true,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    align: 'center',
    width: 150,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_goodsQty') || '产品数',
    field: 'goodsQty',
    align: 'center',
    width: 150,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnQty') || '箱数',
    field: 'ctnQty',
    align: 'center',
    width: 150,
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        controls: false,
        clearable: true,
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_amzBoxNo') || '箱号',
    field: 'amzBoxNo',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 50,
        'show-word-limit': true,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_cbm') || '单箱体积',
    field: 'cbm',
    align: 'center',
    width: 150,
    isTotalColumn: true,
    formatter: ({ row }) => {
      const { ctnLength, ctnWidth, ctnHeight } = row
      return that.format(
        that.divideRound(
          that.multiply(that.multiply(ctnLength, ctnWidth), ctnHeight),
          1000000,
          2
        )
      )
    },
  },
  {
    title: that.$l('table_label_subCbm') || '总体积',
    field: 'subCbm',
    align: 'center',
    width: 150,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnGrossWeight') || '单箱毛重',
    field: 'ctnGrossWeight',
    align: 'center',
    width: 180,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subGrossWeight') || '毛重(KGS)',
    field: 'subGrossWeight',
    align: 'center',
    width: 150,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },

  {
    title: that.$l('table_label_ftyPrice') || '采购单价',
    field: 'ftyPrice',
    align: 'center',
    width: 150,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subAmount') || '成本金额',
    field: 'subAmount',
    align: 'center',
    width: 150,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_detailRemark') || '备注',
    field: 'detailRemark',
    align: 'left',
    headerAlign: 'center',
    width: 300,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 1000,
        'show-word-limit': true,
        clearable: true,
        size: 'mini',
      },
    },
  },
]
